import { render, staticRenderFns } from "./HomeNewPartner.vue?vue&type=template&id=fdfb0636&scoped=true&"
import script from "./HomeNewPartner.vue?vue&type=script&lang=js&"
export * from "./HomeNewPartner.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewPartner.vue?vue&type=style&index=0&id=fdfb0636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfb0636",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VContainer,VFlex,VIcon,VImg,VRow})
